export default __webpack_public_path__ + "static/media/pink-wave-background.ea0ba40e.svg";